import { Icon } from '@core/designsystem';
import type { TaskListItem } from './types';

/**
 * Строка задачи — метрики docs/DESIGN.md, «Строки списков»: высота 58, значок 22.
 *
 * Отметка выполнения стоит слева и нажимается отдельно от строки: «сделано» — самое
 * частое действие на этом экране, и ради него не нужно открывать карточку.
 */
export function TaskRow({
  item,
  onOpen,
  onToggle,
  onMenu,
}: {
  item: TaskListItem;
  onOpen: () => void;
  onToggle: () => void;
  onMenu: () => void;
}) {
  return (
    <div className="task-row">
      <button
        type="button"
        className="task-row__check"
        aria-label={item.isCompleted ? 'Вернуть в работу' : 'Выполнено'}
        aria-pressed={item.isCompleted}
        onClick={onToggle}
      >
        <Icon name={item.isCompleted ? 'check' : 'checklist'} size={22} />
      </button>

      <button
        type="button"
        className="task-row__body"
        onClick={onOpen}
        onContextMenu={(event) => {
          event.preventDefault();
          onMenu();
        }}
      >
        <span className="task-row__texts">
          <span className={`task-row__title ${item.isCompleted ? 'task-row__title--done' : ''}`}>
            {item.title}
          </span>
          <span className={`task-row__timing task-row__timing--${item.timingAccent}`}>
            {item.caseTitle ? `${item.caseTitle} · ${item.timing}` : item.timing}
          </span>
        </span>
      </button>
    </div>
  );
}
